// shared/src/schemas/daily-close.ts
// Zod schema for `daily_closes` table. Composite primary key (ticker, date), WITHOUT ROWID.
// Source enum mirrors the DDL CHECK — keep in lockstep with the migration that owns it.

import { z } from 'zod';

export const DailyCloseSourceEnum = z.enum([
  // The only source written after 2026-07-15 (migration 0099): runClose reads the latest
  // oracle_canonical per key at 16:00 ET instead of calling vendors.
  'oracle_eod',
  // RETAINED for ~4600 rows of history. Nothing writes these now.
  //
  // SEAM — `date` does not mean the same thing on both sides. Rows with source='polygon_eod'
  // hold the PREVIOUS trading day's close (Polygon's /prev returns D-1, and it was stamped with
  // D). MEASURED 2026-07-15; yahoo_eod and coingecko_eod rows are correctly dated, so historical
  // correctness varies BY VENDOR within this column. Never compare a polygon_eod row's date to an
  // oracle_eod row's date and assume the same basis. Full evidence + the 13.6%-verdict-flip
  // measurement: migration 0099.
  'polygon_eod',
  'coingecko_eod',
  'yahoo_eod',
  'cryptocom_eod',
  'legacy_backfill',
]);

export const DailyCloseSchema = z.object({
  ticker:       z.string(),
  date:         z.string(),                 // YYYY-MM-DD (date-only, not full datetime)
  close_price:  z.number().positive(),
  source:       DailyCloseSourceEnum,
  created_at:   z.string().datetime(),
});

export type DailyCloseRow = z.infer<typeof DailyCloseSchema>;
